module.exports = __webpack_public_path__ + "assets/flags/de.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/de.svg
// module id = 497
// module chunks = 0